import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const ShuttleIcon = ({
  title = 'Shuttle',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 64 64" {...props}>
    <g transform="translate(8 7)" stroke="currentColor" fill="none" fillRule="evenodd">
      <path d="M3.774 9c0-4.97 4.038-9 9.003-9h22.56c4.972 0 9.003 4.038 9.003 9v36.283H3.774V9.001Z" />
      <rect x="6.604" y="10.377" width="34.906" height="20.755" rx="1" />
      <path strokeLinejoin="round" d="M0 13.208h3.774v10.377H0zM44.34 13.208h3.774v10.377H44.34z" />
      <path strokeLinecap="round" d="M24.354 10.783v7.157l-5.41 8.034" />
      <rect x="35.849" y="34.906" width="5.66" height="5.66" rx="1" />
      <rect x="6.604" y="34.906" width="5.66" height="5.66" rx="1" />
      <path d="M16.51 36.32h15.094M16.51 39.15h15.094" strokeLinecap="round" />
      <path d="M33.962 45.283h5.66v2.359A2.366 2.366 0 0 1 37.256 50h-.925a2.357 2.357 0 0 1-2.368-2.358v-2.359ZM8.49 45.283h5.66v2.359A2.366 2.366 0 0 1 11.784 50h-.925a2.357 2.357 0 0 1-2.367-2.358v-2.359Z" />
    </g>
  </CreateIconComponent>
);

export default ShuttleIcon;
